export default "__VITE_ASSET__486fbe34__"